import React, { useState, useEffect, lazy, Suspense } from "react";
import CryptoJS from "crypto-js";
const LazyReCAPTCHA = lazy(() => import("../../app_structure/LazyReCAPTCHA"));
function Getlink(props) {
  const showcaptcha = props.data;
  const recaptchaRef = React.createRef();
  const [nutorder, setnutorder] = useState('Vô app momo chuyển cho tớ là Coins lên liền nhé =D');
  const sendDataToParent = (value) => {
    // const newData = /* some data you want to send to the parent */;

    // Gọi hàm callback từ prop để truyền dữ liệu về cha
    props.sendDataToParent(value);
  };
  const handleRecaptchaChange = (value) => {
    // console.log(value);
    const maxLength = 200;
    sendDataToParent(value);
    if (value.length > maxLength) {
      // setnutxuly(1);
      // setnutorder('Bạn hãy đợi vài giây để app xử lý nhé');
      // const myCookieValue = Cookies.get('apikey');
      // let data = JSON.stringify({
      //   "recaptchaValue": value,
      //   "macode": macode,
      //   "apikey": myCookieValue
      // });
      // let config = {
      //   method: 'post',
      //   maxBodyLength: Infinity,
      //   url: 'https://hust.media/api/wallet/momoidcode.php',
      //   headers: {
      //     'Content-Type': 'application/json'
      //   },
      //   data: data
      // };
      // axios.post(config.url, config.data, config.headers)
      //   .then((response) => {
      //     setnutxuly(0);
      //     testFunction(response);
      //   })
      //   .catch((error) => {
      //     setnutxuly(0);
      //     alert_error(error);
      //   });
    }
    else {
      setnutorder('Đã xảy ra lỗi tải lại trang nhé');
    }
  };
  useEffect(() => {
    console.log(4324234234);
    var encrypted = CryptoJS.AES.encrypt("Message", "123")

    var data = encrypted.ciphertext.toString()
    var key = encrypted.key.toString()
    var iv = encrypted.iv.toString()
    console.log(data);
    console.log(key);
    console.log(iv);
  }, []);
  return (
    <>
      {showcaptcha ? (
        <div style={{ textAlign: "center" }} className="mt-0  flex justify-center items-center ">
          
          <Suspense fallback={<div>Loading...</div>}>
            <LazyReCAPTCHA
              recaptchaRef={recaptchaRef}
              handleRecaptchaChange={handleRecaptchaChange}
              sitekey='6LeB3qclAAAAAGkFcUEAgX8Lmi37Frx0m7UUImEN'
            />
          </Suspense>
        </div>) : (<>
          <div style={{ textAlign: "center" }} className="mt-0  flex justify-center items-center ">
            loading ..
          </div></>)}

    </>
  )
}


export default Getlink;
